export default {
  // 按钮
  addLabel: '新增标签',
  edit: '修改',
  delete: '删除',

  // 表格列
  englishLabel: '英文标签',
  chineseLabel: '中文标签',
  createTime: '创建时间',
  updateTime: '更新时间',
  operation: '操作',

  // 弹窗
  addLabelTitle: '新增标签',
  editLabelTitle: '修改标签',

  // 表单字段
  englishLabelField: '英文标签',
  englishLabelPlaceholder: '请输入英文标签',
  chineseLabelField: '中文标签',
  chineseLabelPlaceholder: '请输入中文标签',

  // 校验提示
  englishLabelRequired: '请输入英文标签',
  chineseLabelRequired: '请输入中文标签',

  // 按钮
  cancel: '取消',
  confirm: '确定',

  // 提示消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',

  // 删除确认
  deleteConfirmTitle: '确认删除',
  deleteConfirmContent: '是否删除"{label}"?',
  deleteConfirm: '删除',
}
